import { http } from './http'
import { auth } from './auth'
import { z } from 'zod'
import { AgendaNoteSchema } from '../schemas'
import { parseWithZod } from '../utils/parse-with-zod'

export const actionItems = {
  getAgendaNotes: async (id: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(
      `${regionHost}/api/action_items/${id}/agenda_notes`,
      undefined,
      dealId,
    )
    const parsedResult = parseWithZod(z.object({ agenda_notes: z.array(AgendaNoteSchema) }), result)
    return parsedResult.agenda_notes
  },
}
